import { render } from "./Archived.vue?vue&type=template&id=433c274a"
import script from "./Archived.vue?vue&type=script&lang=js"
export * from "./Archived.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__